/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/json/common/jsonWorker.nls.es", {
	"vs/base/common/http": [
		"Bad request. The request cannot be fulfilled due to bad syntax.",
		"Unauthorized. The server is refusing to respond.",
		"Forbidden. The server is refusing to respond.",
		"Not Found. The requested location could not be found.",
		"Method not allowed. A request was made using a request method not supported by that location.",
		"Not Acceptable. The server can only generate a response that is not accepted by the client.",
		"Proxy Authentication Required. The client must first authenticate itself with the proxy.",
		"Request Timeout. The server timed out waiting for the request.",
		"Conflict. The request could not be completed because of a conflict in the request.",
		"Gone. The requested page is no longer available.",
		"Length Required. The \"Content-Length\" is not defined.",
		"Precondition Failed. The precondition given in the request evaluated to false by the server.",
		"Request Entity Too Large. The server will not accept the request, because the request entity is too large.",
		"Request-URI Too Long. The server will not accept the request, because the URL is too long.",
		"Unsupported Media Type. The server will not accept the request, because the media type is not supported.",
		"Internal Server Error.",
		"Not Implemented. The server either does not recognize the request method, or it lacks the ability to fulfill the request.",
		"Service Unavailable. The server is currently unavailable (overloaded or down).",
		"HTTP status code {0}",
	],
	"vs/languages/json/common/contributions/bowerJSONContribution": [
		"Bower.json predeterminado",
		"Error en la solicitud al repositorio de Bower: {0}",
		"Error en la solicitud al repositorio de Bower: {0}",
		"{0}",
	],
	"vs/languages/json/common/contributions/globPatternContribution": [
		"Archivos por extensión",
		"Hacer coincidir todos los archivos que tengan una extensión de archivo determinada.",
		"Archivos con varias extensiones",
		"Hacer coincidir todos los archivos con cualquiera de las extensiones de archivo.",
		"Archivos con elementos del mismo nivel por nombre",
		"Hacer coincidir archivos que tienen elementos del mismo nivel con el mismo nombre pero con extensión diferente.",
		"Carpeta por nombre (nivel superior)",
		"Hacer coincidir una carpeta de nivel superior con un nombre específico.",
		"Carpetas con varios nombres (nivel superior)",
		"Hacer coincidir varias carpetas de nivel superior.",
		"Carpeta por nombre (cualquier ubicación)",
		"Hacer coincidir una carpeta con un nombre determinado en cualquier ubicación.",
		"True",
		"Habilitar el patrón.",
		"False",
		"Deshabilitar el patrón.",
		"Archivos con elementos del mismo nivel por nombre",
		"Hacer coincidir archivos que tienen elementos del mismo nivel con el mismo nombre pero con extensión diferente.",
	],
	"vs/languages/json/common/contributions/packageJSONContribution": [
		"Package.json predeterminado",
		"Error en la solicitud al repositorio de NPM: {0}",
		"Error en la solicitud al repositorio de NPM: {0}",
		"Versión más reciente del paquete actualmente",
		"Coincide con la versión principal más reciente (1.x.x)",
		"Coincide con la versión secundaria más reciente (1.2.x)",
		"{0}",
		"Versión más reciente: {0}",
	],
	"vs/languages/json/common/contributions/projectJSONContribution": [
		"Project.json predeterminado",
		"Error en la solicitud al repositorio de Nuget: {0}",
		"Error en la solicitud al repositorio de Nuget: {0}",
		"Versión más reciente del paquete actualmente.",
		"{0}",
		"Versión más reciente: {0}",
	],
	"vs/languages/json/common/jsonIntellisense": [
		"Valor predeterminado",
	],
	"vs/languages/json/common/jsonSchemaService": [
		"Unable to load schema from \'{0}\': No content.",
		"Unable to parse content from \'{0}\': {1}.",
		"No se puede cargar el esquema de \'{0}\': {1}.",
		"$ref \'{0}\' in {1} can not be resolved.",
		"Problems loading reference \'{0}\': {1}",
	],
	"vs/languages/json/common/parser/jsonParser": [
		"Tipo incorrecto. Se espera uno de {0}",
		"Tipo incorrecto. Se espera \"{0}\"",
		"Se corresponde con un esquema que no se permite.",
		"Se corresponde con varios esquemas, pero solo se puede validar uno.",
		"El valor no se acepta. Valores válidos: {0}",
		"La matriz tiene demasiados elementos según el esquema. Se esperan {0} o menos",
		"La matriz tiene demasiado pocos elementos. Se esperan {0} o más",
		"La matriz tiene demasiados elementos. Se esperan {0} o menos",
		"La matriz tiene elementos duplicados",
		"El valor no es divisible por {0}",
		"El valor es inferior al mínimo exclusivo de {0}",
		"El valor es inferior al mínimo de {0}",
		"El valor supera el máximo exclusivo de {0}",
		"El valor es superior al máximo de {0}",
		"La longitud de la cadena es menor que el mínimo de ",
		"La longitud de la cadena es inferior al máximo de ",
		"La cadena no se corresponde con el patrón de \"{0}\"",
		"Falta la propiedad \"{0}\"",
		"No se permite la propiedad {0}",
		"El objeto tiene más propiedades que el límite de {0}",
		"El objeto tiene menos propiedades que el número necesario de {0}",
		"El objeto no tiene la propiedad {0}, la cual necesita la propiedad {1}",
		"Secuencia Unicode no válida en la cadena",
		"Carácter de escape no válido en la cadena",
		"Final de número inesperado",
		"Final de comentario inesperado",
		"Final de cadena inesperado",
		"Valor esperado",
		"Se esperaba una coma o un corchete de cierre",
		"Las claves de propiedades deben ir entre comillas dobles",
		"Clave de objeto duplicada",
		"Se esperaban dos puntos",
		"Valor esperado",
		"Propiedad esperada",
		"Se esperaba una coma o una llave de cierre",
		"Formato de número no válido",
		"Formato de número no válido",
		"Se esperaba un objeto JSON, una matriz o un literal",
		"Final de archivo esperado",
	]
});